var TriggerCode = /** @class */ (function () {
    function TriggerCode(code, callback) {
        this.code = code;
        this.callback = callback;
    }
    TriggerCode.prototype.characterIsValid = function (char, index) {
        return this.code[index] === char;
    };
    TriggerCode.prototype.isLastCharacter = function (charIndex) {
        return this.code.length - 1 === charIndex;
    };
    TriggerCode.prototype.invokeCallback = function () {
        this.callback();
    };
    TriggerCode.prototype.invokeCallbackIfIsLastCharacter = function (charIndex) {
        if (!this.isLastCharacter(charIndex)) {
            return;
        }
        this.invokeCallback();
    };
    return TriggerCode;
}());
export default TriggerCode;
//# sourceMappingURL=TriggerCode.js.map